
import React from "react";
import { Button } from "@/components/ui/button";
import { Loader, User } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { authService } from "@/services/auth.service";

interface UserHeaderProps {
  user: any;
  loading: boolean;
  handleLogout?: () => Promise<void>;
}

const UserHeader = ({ user, loading, handleLogout }: UserHeaderProps) => {
  const navigate = useNavigate();

  const handleAuthAction = () => {
    if (user) {
      if (handleLogout) {
        handleLogout();
      } else {
        handleLogoutDefault();
      }
    } else {
      navigate("/auth");
    }
  };

  const handleLogoutDefault = async () => {
    try {
      await authService.signOut();
      toast.success("Logged out successfully");
      navigate("/auth");
    } catch (error) {
      console.error("Error logging out:", error);
      toast.error("Failed to log out. Please try again.");
    }
  };

  return (
    <div className="flex justify-end mb-8">
      {loading ? (
        <Loader className="animate-spin h-5 w-5 text-[#5A636E]" />
      ) : (
        <Button
          variant="ghost"
          size="sm"
          onClick={handleAuthAction}
          className="text-[#5A636E] hover:text-[#333B44]"
        >
          <User className="mr-2 h-4 w-4" />
          {user ? "Log out" : "Log in / Register"}
        </Button>
      )}
    </div>
  );
};

export default UserHeader;
